import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "secondsToHumanRange" })
export class SecondsToHumanRangePipe implements PipeTransform {
    transform(totalSeconds: number, includeSeconds: boolean = true) {
        if (totalSeconds === null) {
            return;
        }

        const secondsDuration = moment.duration(totalSeconds, "seconds");
        const years = secondsDuration.years();
        const months = secondsDuration.months();
        const days = secondsDuration.days();
        const hours = secondsDuration.hours();
        const minutes = secondsDuration.minutes();
        const seconds = secondsDuration.seconds();

        const humanRange = (
            (years ? years + "y " : "") +
            (months ? months + "mo " : "") +
            (days ? days + "d " : "") +
            (hours ? hours + "h " : "") +
            (minutes ? minutes + "m " : "") +
            ((seconds && includeSeconds) ? seconds + "s" : "")
        ).trim();

        return humanRange ? humanRange : `${ seconds }s`;
    }
}
